export default "/dist/files/choix_animation_roue_chance.6792bc0665a617cad4b80370ee97bbff.svg";